import { usersService } from "@/app/services/usersService";
import { useToast } from "@/view/components/ui/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

export const usePersonalInfoController = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const [isCommissionModalOpen, setIsCommissionModalOpen] = useState(false);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      return usersService.userUnicoApprove(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["sellerInfo", id],
      });
    },
  });

  const { toast } = useToast();

  const handleUnicoApprove = async () => {
    try {
      if (id) {
        await mutateAsync({ id });

        toast({
          title: "Unico aprovado com sucesso!",
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        variant: "destructive",
        title:
          "Ocorreu um erro ao tentar aprovar a Unico, tente novamente mais tarde.",
      });
    }
  };

  return {
    isCommissionModalOpen,
    setIsCommissionModalOpen,
    handleUnicoApprove,
    isPending,
  };
};
